/*
 * bAK Slide-Progress-Indicator (Cowork 2026-05-27)
 * ────────────────────────────────────────────────
 * Toggled .is-active class auf .bak-progress__seg basierend auf welcher
 * <slideshow-slide> gerade aria-hidden="false" hat.
 *
 * STRENG: KEINE getBoundingClientRect, KEINE Position-Berechnung, KEINE Pixel-Math.
 * Die VISUELLE Position der aktiven Linie wird zu 100% durch CSS-Grid bestimmt.
 * Dieses Script setzt nur Klassen.
 */
(function () {
  'use strict';

  function markActive(segs, activeIdx) {
    for (var j = 0; j < segs.length; j++) {
      var shouldBeActive = (j === activeIdx);
      if (segs[j].classList.contains('is-active') !== shouldBeActive) {
        segs[j].classList.toggle('is-active', shouldBeActive);
      }
    }
  }

  function setupGallery(gallery, progress) {
    var allSlides = gallery.querySelectorAll('slideshow-slide');
    // bAK Kategorieübersicht: Video-Slides KOMPLETT raus aus der Card-Gallery —
    // ausschalten (pause), Slide hidden, damit Swipe + Indicator nicht weiterzählen.
    Array.prototype.forEach.call(allSlides, function (s) {
      if (s.__bakVideoChecked) return;
      var vid = s.querySelector('video, video-component, [data-shopify-video-component-deferred-element]');
      if (vid) {
        s.__bakVideoChecked = true;
        s.setAttribute('hidden', '');
        s.style.display = 'none';
        // Falls echtes <video> Element: pausen + autoplay off
        var realVid = s.querySelector('video');
        if (realVid) {
          try { realVid.pause(); } catch (e) { /* swallow */ }
          realVid.autoplay = false;
          realVid.removeAttribute('autoplay');
          realVid.muted = true;
        }
      }
    });
    // FILTER: nur Slides die wirklich sichtbar sind (keine hidden variant-images, keine Videos)
    var slides = Array.prototype.filter.call(allSlides, function (s) {
      return !s.hasAttribute('hidden') && getComputedStyle(s).display !== 'none';
    });
    var segs = progress.querySelectorAll('.bak-progress__seg');
    var scroller = gallery.querySelector('slideshow-slides');
    if (!slides.length || !segs.length) return;

    // Überschüssige Segmente verstecken wenn mehr Segmente als sichtbare Slides
    if (segs.length > slides.length) {
      for (var x = slides.length; x < segs.length; x++) {
        segs[x].style.display = 'none';
      }
      // Re-query nur die sichtbaren Segs für weitere Logik
      segs = Array.prototype.filter.call(segs, function (s) {
        return s.style.display !== 'none';
      });
    }

    // Initial state — first slide with aria-hidden="false" is active.
    var initialIdx = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('aria-hidden') === 'false') {
        initialIdx = i;
        break;
      }
    }
    markActive(segs, Math.min(initialIdx, segs.length - 1));

    // TRIGGER 1: MutationObserver auf aria-hidden (primär, Horizons IntersectionObserver setzt dies).
    var observer = new MutationObserver(function (mutations) {
      var newActiveIdx = -1;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.attributeName !== 'aria-hidden') continue;
        if (m.target.getAttribute('aria-hidden') === 'false') {
          var idx = Array.prototype.indexOf.call(slides, m.target);
          if (idx >= 0 && idx < segs.length) newActiveIdx = idx;
        }
      }
      if (newActiveIdx >= 0) markActive(segs, newActiveIdx);
    });
    for (var k = 0; k < slides.length; k++) {
      observer.observe(slides[k], { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    // TRIGGER 2 (Fallback): scroll-position auf slideshow-slides.
    // Safari 15 hat bekannte Bugs mit IntersectionObserver in verschachtelten Scroll-
    // Containern (CTL/YML auf der PDP). Diese Fallback-Logik berechnet den aktiven
    // Slide aus scrollLeft / slideWidth — funktioniert garantiert in jedem Browser.
    if (scroller) {
      var scrollTimer = null;
      var lastScrollIdx = -1;
      function onScroll() {
        if (scrollTimer) return;
        scrollTimer = requestAnimationFrame(function () {
          scrollTimer = null;
          var slideWidth = slides[0] ? slides[0].getBoundingClientRect().width : 0;
          if (!slideWidth) return;
          var idx = Math.round(scroller.scrollLeft / slideWidth);
          if (idx < 0) idx = 0;
          if (idx >= segs.length) idx = segs.length - 1;
          if (idx !== lastScrollIdx) {
            lastScrollIdx = idx;
            markActive(segs, idx);
          }
        });
      }
      scroller.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function findGalleryFor(progress) {
    if (progress.closest) {
      var parent = progress.closest('.card-gallery');
      if (parent) return parent;
    }
    var prev = progress.previousElementSibling;
    while (prev) {
      if (prev.classList && prev.classList.contains('card-gallery')) return prev;
      if (prev.querySelector) {
        var nested = prev.querySelector('.card-gallery');
        if (nested) return nested;
      }
      prev = prev.previousElementSibling;
    }
    if (progress.parentElement) {
      return progress.parentElement.querySelector('.card-gallery');
    }
    return null;
  }

  function init() {
    var nodes = document.querySelectorAll('.bak-progress');
    for (var i = 0; i < nodes.length; i++) {
      var progress = nodes[i];
      if (progress.__bakInit) continue;
      var gallery = findGalleryFor(progress);
      if (!gallery) continue;
      progress.__bakInit = true;
      setupGallery(gallery, progress);
    }
  }

  // Debounce wrapper für MutationObserver der lazy-geladene Sections beobachtet
  var initTimer = null;
  function scheduleInit() {
    if (initTimer) clearTimeout(initTimer);
    initTimer = setTimeout(init, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init für dynamisch geladene Sections (Filter, Pagination, Theme-Editor)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:block:select', init);

  // Wishlist-App-Trigger: dispatch shopify:section:load auf neue Sections,
  // damit die Wishlist-App (die selbst KEINEN MutationObserver hat) Hearts
  // auf lazy-geladene Cards injiziert. Nur einmal pro Section.
  var wishlistTriggeredSections = new WeakSet();
  function triggerWishlistOnSection(node) {
    var section = node.closest ? node.closest('[id^="shopify-section-"]') : null;
    if (!section || wishlistTriggeredSections.has(section)) return;
    wishlistTriggeredSections.add(section);
    try {
      section.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: section.id }
      }));
    } catch (e) {
      // older browsers might need CustomEvent shim — ignore failures
    }
  }

  // Watch for lazy-loaded sections: "Complete the Look", "You may also like",
  // filter results, pagination AJAX, etc. — die werden nach DOMContentLoaded
  // via Shopify Section Rendering API ins DOM injiziert.
  if ('MutationObserver' in window && document.body) {
    var bodyObserver = new MutationObserver(function (mutations) {
      var triggered = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          var isProgress = node.classList && node.classList.contains('bak-progress');
          var hasProgress = !isProgress && node.querySelector && node.querySelector('.bak-progress');
          if (isProgress || hasProgress) {
            if (!triggered) { scheduleInit(); triggered = true; }
            triggerWishlistOnSection(isProgress ? node : node);
          }
        }
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK Card-Gallery Mouse-Drag Fix (Cowork 2026-05-27)
 * ────────────────────────────────────────────────────
 * Macht Maus-Drag auf Card-Galleries zuverlässig:
 *   1. dragstart preventDefault → kein natives Link-Drag&Drop (Ghost-Image)
 *   2. pointerdown/move tracking → erkennt ob User gedragged hat
 *   3. click blocken (capture phase) wenn der vorhergehende pointer Move
 *      > Threshold war → Link öffnet sich NICHT
 *
 * Horizons slideshow-component übernimmt das eigentliche Swipen (sie hat
 * mousedown→pointermove Logik). Wir blockieren nur den finalen Click
 * der sonst zum Produkt navigieren würde.
 *
 * Tap/Klick OHNE Bewegung → Link funktioniert normal (öffnet Produktseite).
 * Drag MIT Bewegung → Horizon swipt das Bild, Link NICHT navigiert.
 */
(function () {
  'use strict';
  var THRESHOLD = 5; // px movement to count as "drag" vs "click"
  var startX = 0, startY = 0, moved = false, activePointerId = -1;

  // Prevent native link drag-and-drop (ghost image)
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.closest && e.target.closest('.card-gallery')) {
      e.preventDefault();
    }
  }, true);

  // Track pointer movement on card-gallery to determine if drag or click
  document.addEventListener('pointerdown', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.card-gallery')) return;
    startX = e.clientX;
    startY = e.clientY;
    moved = false;
    activePointerId = e.pointerId;
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (e.pointerId !== activePointerId) return;
    if (Math.abs(e.clientX - startX) > THRESHOLD || Math.abs(e.clientY - startY) > THRESHOLD) {
      moved = true;
    }
  }, true);

  // Block click that follows a drag (capture phase = before link handler)
  // NUR auf <a href> Links — Buttons (Quick-Add, Wishlist-Heart) gehen durch.
  // Sonst wird das Quick-Add-Modal geblockt weil moved=true zwischen Slideshow-
  // Swipes hängenbleiben kann (Horizons pointer-capture).
  document.addEventListener('click', function (e) {
    if (moved && e.target && e.target.closest) {
      var link = e.target.closest('a[href]');
      if (link && link.closest('.card-gallery')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }
    moved = false;
    activePointerId = -1;
  }, true);

  // Reset on cancel
  document.addEventListener('pointercancel', function (e) {
    if (e.pointerId === activePointerId) { moved = false; activePointerId = -1; }
  }, true);
})();

/*
 * bAK Wishlist Position Override (Cowork 2026-05-27)
 * ────────────────────────────────────────────────────
 * Die Wishlist-App setzt inline `style="inset: ... !important"` auf den
 * Heart-Buttons. Inline-!important schlägt jede externe CSS-Regel (das ist
 * die einzige CSS-Hierarchie wo external CSS NICHT gewinnen kann).
 * Diese JS-Logik überschreibt die inline-Werte:
 *   - PDP-Heart: 12px top + right
 *   - Card-Heart: rechts unten, gestapelt über Quick-Add (Cards bekommen den
 *     Position-Override auch via JS als Safari-15-Fallback, falls dort
 *     externes CSS nicht greift)
 */
(function () {
  'use strict';

  // Marker um zu erkennen ob wir unsere Werte gerade setzen (verhindert
  // Endlosschleife im AttributeObserver auf style)
  var WL_TRACKED = new WeakSet();
  var APPLYING = new WeakSet();

  function fixPdpOverlay(el) {
    APPLYING.add(el);
    el.style.setProperty('inset', '6px 6px auto auto', 'important');
    el.style.setProperty('top', '6px', 'important');
    el.style.setProperty('right', '6px', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('left', 'auto', 'important');
    setTimeout(function(){ APPLYING.delete(el); }, 0);
  }

  function fixCardOverlay(el) {
    APPLYING.add(el);
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var inset = isMobile ? 12 : 16;
    var btnSize = 18;
    var gap = 6;
    var bottom = inset + btnSize + gap;
    el.style.setProperty('inset', 'auto ' + inset + 'px ' + bottom + 'px auto', 'important');
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('left', 'auto', 'important');
    el.style.setProperty('right', inset + 'px', 'important');
    el.style.setProperty('bottom', bottom + 'px', 'important');
    el.style.setProperty('width', btnSize + 'px', 'important');
    el.style.setProperty('height', btnSize + 'px', 'important');
    setTimeout(function(){ APPLYING.delete(el); }, 0);
  }

  function fixOne(el) {
    if (el.classList.contains('wishlist-overlay--pdp')) {
      fixPdpOverlay(el);
    } else if (el.classList.contains('wishlist-overlay--card') || el.classList.contains('wishlist-overlay')) {
      // Card-Overlay nur wenn es in einer .card-gallery sitzt
      if (el.closest && el.closest('.card-gallery')) {
        fixCardOverlay(el);
      }
    }
  }

  // Beobachte den style-Attribut jedes Overlays: wenn die Wishlist-App
  // ihre inline-Styles setzt, fixen wir sofort danach wieder.
  function attachStyleObserver(el) {
    if (WL_TRACKED.has(el)) return;
    WL_TRACKED.add(el);
    // Initial fix
    fixOne(el);
    // Re-fix bei style-Änderungen
    var styleObs = new MutationObserver(function (mutations) {
      if (APPLYING.has(el)) return; // ignore our own changes
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'style') {
          fixOne(el);
          return;
        }
      }
    });
    styleObs.observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  function fixAll() {
    document.querySelectorAll('.wishlist-overlay--pdp').forEach(attachStyleObserver);
    document.querySelectorAll('.card-gallery .wishlist-overlay--card, .card-gallery .wishlist-overlay').forEach(function (el) {
      if (!el.classList.contains('wishlist-overlay--pdp')) attachStyleObserver(el);
    });
  }

  var fixTimer = null;
  function scheduleFix() {
    if (fixTimer) clearTimeout(fixTimer);
    fixTimer = setTimeout(fixAll, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }
  document.addEventListener('shopify:section:load', scheduleFix);

  // Beobachte neue Wishlist-Overlay Nodes (lazy-loaded sections / app-injection)
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && (n.classList.contains('wishlist-overlay') || n.classList.contains('wishlist-overlay--card') || n.classList.contains('wishlist-overlay--pdp'))) {
            attachStyleObserver(n);
          } else if (n.querySelector) {
            var inner = n.querySelectorAll('.wishlist-overlay, .wishlist-overlay--card, .wishlist-overlay--pdp');
            for (var k = 0; k < inner.length; k++) attachStyleObserver(inner[k]);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Re-fix on window resize (breakpoint change for card overlays)
  window.addEventListener('resize', function () {
    document.querySelectorAll('.card-gallery .wishlist-overlay--card').forEach(fixCardOverlay);
  });
})();

/*
 * bAK Single-Variant Größenlabel Hider (Cowork 2026-05-27)
 * Browser-übergreifend (auch Safari 15.0-15.3 ohne :has() Support):
 * Setzt data-bak-single-hidden auf .variant-option Elemente die nur EINEN
 * Wert haben (z.B. "Größe One size") — CSS blendet sie dann aus.
 */
(function () {
  'use strict';
  function hideSingles() {
    var singles = document.querySelectorAll('.variant-option__swatch-value[data-testid="variant-option-single-value"]');
    for (var i = 0; i < singles.length; i++) {
      var parent = singles[i].closest('.variant-option');
      if (parent && !parent.hasAttribute('data-bak-single-hidden')) {
        parent.setAttribute('data-bak-single-hidden', '');
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSingles);
  } else {
    hideSingles();
  }
  document.addEventListener('shopify:section:load', hideSingles);
  // Observe DOM for dynamically-rendered variant pickers (variant changes, etc.)
  if ('MutationObserver' in window && document.body) {
    var t = null;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(hideSingles, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK PDP Wishlist-Heart Per-Slide Distribution (Cowork 2026-05-27)
 * ─────────────────────────────────────────────────────────────────
 * Die Wishlist-App injiziert nur EINEN Heart in den gallery-container.
 * Beim Swipen durch die PDP-Bilder erscheint er aber nicht auf jedem Slide.
 * Dieses Script klont den Heart in jeden slideshow-slide → 1 Heart pro Bild,
 * jeder fix top:6px / right:6px. Klick wird via dispatch zum Original delegiert
 * damit die Wishlist-Logik funktioniert.
 */
(function () {
  'use strict';

  var DISTRIBUTED = new WeakSet();
  var STATE_OBSERVED = new WeakSet();

  function distributeHearts() {
    var galleries = document.querySelectorAll('.product-information slideshow-component');
    galleries.forEach(function (gallery) {
      var original = gallery.querySelector('.wishlist-overlay--pdp:not(.bak-heart-clone)');
      if (!original) return;
      var slides = gallery.querySelectorAll('slideshow-slide');
      if (!slides.length) return;

      // Hide original
      original.style.setProperty('display', 'none', 'important');

      // Observer auf Original's Class (für Active-State Sync) — robuster als setTimeout
      if (!STATE_OBSERVED.has(original)) {
        STATE_OBSERVED.add(original);
        try {
          new MutationObserver(function () {
            syncCloneStates(gallery);
          }).observe(original, {
            attributes: true,
            attributeFilter: ['class', 'aria-pressed', 'data-active'],
            subtree: true
          });
        } catch (e) { /* swallow */ }
      }

      slides.forEach(function (slide) {
        if (DISTRIBUTED.has(slide)) return;
        if (slide.querySelector('.bak-heart-clone')) return;

        var clone = original.cloneNode(true);
        clone.classList.add('bak-heart-clone');
        clone.removeAttribute('id');
        // Inline-Style mit !important für maximale Spezifität (Safari-15-safe, kein :has)
        clone.style.cssText = 'display:block !important;position:absolute !important;top:6px !important;right:6px !important;bottom:auto !important;left:auto !important;z-index:10 !important;';

        // Slide positioning-context sicherstellen
        if (getComputedStyle(slide).position === 'static') {
          slide.style.position = 'relative';
        }

        var cloneBtn = clone.querySelector('.wishlist-btn, button, a');
        var origBtn = original.querySelector('.wishlist-btn, button, a');
        if (cloneBtn && origBtn) {
          // stopImmediatePropagation verhindert dass evtl. Wishlist-App-Delegation
          // das gleiche Click-Event auf der Klon-Hierarchie doppelt fängt
          cloneBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            // Direct call auf Original — fires app's click handler exactly once
            origBtn.click();
            // syncCloneStates läuft automatisch via Class-MutationObserver oben,
            // kein setTimeout nötig
          }, true); // capture phase — fired BEFORE any bubble delegation
        }

        slide.appendChild(clone);
        DISTRIBUTED.add(slide);
      });

      // Initial state sync (falls Original schon active beim Klonen war)
      syncCloneStates(gallery);
    });
  }

  function syncCloneStates(gallery) {
    var galleries = gallery ? [gallery] : document.querySelectorAll('.product-information slideshow-component');
    Array.prototype.forEach.call(galleries, function (g) {
      var original = g.querySelector('.wishlist-overlay--pdp:not(.bak-heart-clone)');
      if (!original) return;
      // Detect active state — check multiple possible class/attr indicators
      var origBtn = original.querySelector('.wishlist-btn');
      var isActive = !!(origBtn && (origBtn.classList.contains('is-active') || origBtn.getAttribute('aria-pressed') === 'true' || origBtn.hasAttribute('data-active')));
      var origClasses = origBtn ? origBtn.className : '';
      var clones = g.querySelectorAll('.bak-heart-clone');
      Array.prototype.forEach.call(clones, function (c) {
        var cBtn = c.querySelector('.wishlist-btn');
        if (!cBtn) return;
        // Spiegle exakt die Klassen vom Original (für volle visuelle Parity)
        if (origClasses && cBtn.className !== origClasses) {
          cBtn.className = origClasses;
        }
        cBtn.classList.toggle('is-active', isActive);
        if (origBtn && origBtn.hasAttribute('aria-pressed')) {
          cBtn.setAttribute('aria-pressed', origBtn.getAttribute('aria-pressed'));
        }
      });
    });
  }

  var distTimer = null;
  function scheduleDistribute() {
    if (distTimer) clearTimeout(distTimer);
    distTimer = setTimeout(distributeHearts, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleDistribute);
  } else {
    scheduleDistribute();
  }
  document.addEventListener('shopify:section:load', scheduleDistribute);

  // Watch for new wishlist overlays being injected by the app
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.classList && n.classList.contains('wishlist-overlay--pdp')) ||
              (n.querySelector && n.querySelector('.wishlist-overlay--pdp'))) {
            scheduleDistribute();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK Hide bak-progress in "Complete the Look" (Cowork 2026-05-27)
 * ────────────────────────────────────────────────────────────────
 * CTL swiped horizontal zwischen Produkten — der Per-Bild-Indikator pro Card
 * wäre dort verwirrend. YML (You may also like) ist Grid → Indikator bleibt.
 * Identifikation via Heading-Text "COMPLETE THE LOOK" (case-insensitive).
 */
(function () {
  'use strict';
  var CTL_PATTERNS = /complete\s*the\s*look|outfit\s*komplett|den\s*look\s*komplett/i;

  function markCTLSections() {
    // Find all product-recommendations or section-resource-list containers
    var sections = document.querySelectorAll('product-recommendations, .section-resource-list, [class*="resource-list"]');
    Array.prototype.forEach.call(sections, function (sec) {
      if (sec.classList.contains('bak-no-progress')) return;
      // Look for heading text inside this section
      var headings = sec.querySelectorAll('h1, h2, h3, h4, h5, h6, [class*="heading"], [class*="title"]');
      var isCTL = false;
      for (var i = 0; i < headings.length; i++) {
        if (CTL_PATTERNS.test(headings[i].textContent || '')) {
          isCTL = true;
          break;
        }
      }
      if (isCTL) {
        sec.classList.add('bak-no-progress');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markCTLSections);
  } else {
    markCTLSections();
  }
  document.addEventListener('shopify:section:load', markCTLSections);

  // Re-check when product recommendations lazy-load
  if ('MutationObserver' in window && document.body) {
    var t = null;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(markCTLSections, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK Homepage-Detection (Cowork 2026-05-27)
 * Horizon hat keine body.template-index Klasse → wir setzen unsere eigene
 * bak-home Klasse basierend auf pathname für Card-Heart-Verstecken etc.
 */
(function () {
  'use strict';
  function setHomeFlag() {
    var isHome = window.location.pathname === '/' || /^\/(de|en|fr|es|it)\/?$/.test(window.location.pathname);
    document.body.classList.toggle('bak-home', isHome);
  }
  if (document.body) {
    setHomeFlag();
  } else {
    document.addEventListener('DOMContentLoaded', setHomeFlag);
  }
})();

/*
 * bAK Quick-Add-Modal Multi-Picker Labels (Cowork 2026-05-27)
 * ──────────────────────────────────────────────────────────
 * Wenn das Modal mehr als einen Varianten-Picker hat (z.B. Bundle mit zwei
 * Produkten), wird unter jedem Picker ein Label mit dem Namen angezeigt
 * (z.B. "Pullover GRANNY (Größe)"). Bei nur EINEM Picker bleibt es versteckt.
 * Text aus dem <legend> (das per CSS visually-hidden ist) wird extrahiert
 * und als sichtbares Label nach den Buttons eingefügt.
 */
(function () {
  'use strict';
  function processContainer(container) {
    if (!container) return;
    var opts = container.querySelectorAll('.variant-option');
    if (opts.length <= 1) {
      container.classList.remove('bak-multi-picker-container');
      container.querySelectorAll('.bak-picker-name').forEach(function (l) { l.remove(); });
      return;
    }
    container.classList.add('bak-multi-picker-container');
    Array.prototype.forEach.call(opts, function (opt) {
      // Skip wenn schon vorhanden (jetzt als sibling AFTER variant-option)
      if (opt.nextElementSibling && opt.nextElementSibling.classList && opt.nextElementSibling.classList.contains('bak-picker-name')) return;
      var legend = opt.querySelector('legend');
      if (!legend) return;
      var labelText = (legend.textContent || '').trim();
      if (!labelText) return;
      var div = document.createElement('div');
      div.className = 'bak-picker-name';
      div.textContent = labelText;
      // ALS SIBLING einfügen (NICHT in der variant-option Grid drin)
      opt.insertAdjacentElement('afterend', div);
    });
  }

  function processModal() {
    // Quick-Add-Modal
    var modalContent = document.querySelector('dialog.quick-add-modal .quick-add-modal__content');
    if (modalContent) processContainer(modalContent);
    // PDP main product info
    var pdpInfo = document.querySelectorAll('.product-information .product-details, .product-information variant-picker');
    Array.prototype.forEach.call(pdpInfo, function (c) {
      // Find the closest container that holds all variant-options for the SAME product
      var pickerParent = c.closest('.product-details, .product-information') || c;
      processContainer(pickerParent);
    });
  }
  // Expose für den Pre-Morph Hook unten — kann auf beliebigem Container laufen
  window.__bakProcessMultiPicker = processContainer;
  var t = null;
  function schedule() {
    if (t) clearTimeout(t);
    t = setTimeout(processModal, 80);
  }
  // Initial run on page load (PDP needs this — sonst keine Labels bis Section reload)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  document.addEventListener('shopify:section:load', schedule);
  // Auch wenn Modal sich öffnet (dialog open event)
  document.addEventListener('click', function (e) {
    // wenn quick-add button geklickt → process nach kurzem delay
    if (e.target && e.target.closest && e.target.closest('.quick-add__button')) {
      setTimeout(processModal, 600);
      setTimeout(processModal, 1500); // backup
    }
  }, true);
  // MutationObserver auf dialog für Inhalt-Updates
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.classList && (n.classList.contains('variant-option') || n.classList.contains('quick-add-modal__content'))) ||
              (n.querySelector && (n.querySelector('.variant-option') || n.querySelector('.quick-add-modal__content')))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK Pflegehinweise-Accordion-Flush (Cowork 2026-05-28)
 * Findet die "PFLEGEHINWEISE" Accordion-Items auf der PDP und setzt die Klasse
 * bak-pflege-flush — damit kann CSS den Inhalt links bündig mit der Summary
 * ausrichten. JS-basiert, weil :has(summary:contains()) kein CSS ist.
 */
(function () {
  'use strict';
  var PATTERN = /pflege/i;
  function markPflege() {
    var details = document.querySelectorAll('.product-information details, .product-information accordion-custom, .product-information .accordion');
    Array.prototype.forEach.call(details, function (d) {
      if (d.classList.contains('bak-pflege-flush')) return;
      var summary = d.querySelector('summary');
      var text = (summary && summary.textContent) || '';
      if (PATTERN.test(text)) {
        d.classList.add('bak-pflege-flush');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markPflege);
  } else {
    markPflege();
  }
  document.addEventListener('shopify:section:load', markPflege);
  if ('MutationObserver' in window && document.body) {
    var t = null;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(markPflege, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK Bundle ONE SIZE Stub-Injection (Cowork 2026-05-28)
 * ──────────────────────────────────────────────────────
 * Wenn ein Bundle-Produkt im Titel 3 Items aufzählt aber nur 2 Variant-Picker
 * hat (das dritte Item ist one-size), injizieren wir an der korrekten Stelle
 * eine ONE SIZE Pseudo-Picker-Zeile + Label, damit der Kunde sieht welches
 * Item zu welcher Größe gehört. Gilt für PDP + Quick-Add Modal.
 */
(function () {
  'use strict';

  function parseBundleNames(titleText) {
    if (!titleText) return [];
    // "Bundle: A, B & C" → ["A", "B", "C"]
    var cleaned = titleText.replace(/^\s*bundle\s*:?\s*/i, '');
    return cleaned.split(/\s*(?:&|,)\s*/)
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; });
  }

  function getPickerName(picker) {
    var legend = picker.querySelector('legend');
    if (!legend) return '';
    // "Pullover GRANNY (Größe)" → "Pullover GRANNY"
    return (legend.textContent || '').replace(/\s*\(.*?\)\s*$/, '').trim();
  }

  function namesMatch(a, b) {
    if (!a || !b) return false;
    return a.toLowerCase().trim() === b.toLowerCase().trim();
  }

  function createOneSizeStub(productName) {
    var wrapper = document.createElement('div');
    wrapper.className = 'bak-onesize-stub';
    wrapper.setAttribute('data-bak-onesize', productName);

    var fieldset = document.createElement('fieldset');
    fieldset.className = 'variant-option variant-option--buttons bak-onesize-fieldset';
    // Inline styles damit die fieldset.variant-option-margin Regel anders trifft;
    // Grid 1 Spalte für den vollbreiten Button
    fieldset.style.cssText = 'border:0; padding:0; margin:6px 0 0; display:grid; grid-template-columns:1fr;';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bak-onesize-btn';
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'ONE SIZE';
    fieldset.appendChild(btn);

    var label = document.createElement('div');
    label.className = 'bak-picker-name';
    label.textContent = productName + ' (Größe)';

    wrapper.appendChild(fieldset);
    wrapper.appendChild(label);
    return wrapper;
  }

  function injectOneSizeRows(container, titleText) {
    if (!container) return;
    var bundleNames = parseBundleNames(titleText);
    if (bundleNames.length < 2) return;

    // Alle bereits existierenden Picker (echt) + bereits injizierte Stubs
    var pickers = Array.prototype.slice.call(container.querySelectorAll('.variant-option:not(.bak-onesize-fieldset)'));
    if (pickers.length === 0 || pickers.length >= bundleNames.length) return;

    var pickerNames = pickers.map(getPickerName);

    // Pro Bundle-Name das in pickers fehlt: Stub einfügen an korrekter Position
    bundleNames.forEach(function (name, idx) {
      // Überspringen wenn Picker existiert
      var hasPicker = pickerNames.some(function (pn) { return namesMatch(pn, name); });
      if (hasPicker) return;
      // Überspringen wenn Stub schon da
      var exists = container.querySelector('[data-bak-onesize="' + name.replace(/"/g, '\\"') + '"]');
      if (exists) return;

      var stub = createOneSizeStub(name);

      // Insertion-Point bestimmen: nach Picker mit prev-Index, oder vor erstem Picker
      var prevName = null;
      for (var k = idx - 1; k >= 0; k--) {
        if (pickerNames.some(function (pn) { return namesMatch(pn, bundleNames[k]); })) {
          prevName = bundleNames[k];
          break;
        }
      }

      var anchor = null;
      if (prevName) {
        for (var i = 0; i < pickers.length; i++) {
          if (namesMatch(pickerNames[i], prevName)) { anchor = pickers[i]; break; }
        }
      }

      if (anchor) {
        // Horizon kann ALLE variant-options in EINEM variant-picker/form bündeln.
        // Insert als Sibling der .variant-option selber (samt vorhandenem
        // bak-picker-name Label danach) — NICHT als Sibling vom variant-picker
        // (das würde am Ende landen).
        var anchorParent = anchor.parentElement;
        var insertAfter = anchor;
        // Wenn das nächste Element unser bak-picker-name Label vom multi-picker
        // Script ist → wir wollen NACH dem Label einfügen
        var next = anchor.nextElementSibling;
        if (next && next.classList && next.classList.contains('bak-picker-name')) {
          insertAfter = next;
        }
        anchorParent.insertBefore(stub, insertAfter.nextSibling);
      } else {
        // Kein prev-Picker → vor den ersten Picker (als Sibling der variant-option)
        var firstOpt = pickers[0];
        firstOpt.parentElement.insertBefore(stub, firstOpt);
      }
    });
  }

  // Expose für den Pre-Morph Hook unten
  window.__bakInjectOneSizeRows = injectOneSizeRows;

  function process() {
    // PDP
    var pdp = document.querySelector('.product-information');
    if (pdp) {
      var pdpTitle = pdp.querySelector('h1, h2, .product-title');
      var pdpTitleText = pdpTitle && pdpTitle.textContent;
      injectOneSizeRows(pdp, pdpTitleText);
    }
    // Quick-Add Modal
    var modal = document.querySelector('dialog.quick-add-modal[open] .quick-add-modal__content');
    if (modal) {
      var modalTitle = modal.querySelector('h1, h2, .product-title') ||
                       document.querySelector('dialog.quick-add-modal[open] [data-bak-current-handle]');
      var modalTitleText = modalTitle && (modalTitle.textContent || modalTitle.getAttribute('data-bak-current-handle'));
      injectOneSizeRows(modal, modalTitleText);
    }
  }

  var t = null;
  function schedule(delay) {
    if (t) clearTimeout(t);
    t = setTimeout(process, delay !== undefined ? delay : 120);
  }
  // Synchron, ohne Debounce (für variantUpdate damit kein Flash entsteht)
  function processNow() {
    if (t) clearTimeout(t);
    process();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  document.addEventListener('shopify:section:load', schedule);
  // Wenn Variant-Picker im Modal getriggert → Horizon morph re-renders modal-content
  // → mein injizierter Stub fällt raus. Direkt nach dem morph wieder rein, OHNE Debounce.
  document.addEventListener('variant:update', processNow);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quick-add-modal__content variant-picker')) {
      // morph läuft asynchron — Timer 0 hängt sich an die nächste Microtask
      setTimeout(processNow, 0);
      // Backup falls morph länger braucht
      setTimeout(processNow, 50);
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quick-add__button')) {
      setTimeout(process, 700);
      setTimeout(process, 1600);
    }
  }, true);
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (muts) {
      var trigger = false;
      var inModal = false;
      for (var i = 0; i < muts.length && !trigger; i++) {
        var target = muts[i].target;
        if (target && target.closest && target.closest('.quick-add-modal__content')) inModal = true;
        var added = muts[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.classList && (n.classList.contains('variant-option') || n.classList.contains('quick-add-modal__content'))) ||
              (n.querySelector && (n.querySelector('.variant-option') || n.querySelector('.quick-add-modal__content')))) {
            trigger = true; break;
          }
        }
      }
      if (trigger) {
        // Im Modal: SOFORT re-injizieren (kein Debounce) damit kein Sprung entsteht
        if (inModal) processNow();
        else schedule();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK Sale / Special Deal Badge (Cowork 2026-05-28)
 * ─────────────────────────────────────────────────
 * Wenn ein Produkt einen Streichpreis hat (compare_at_price > price):
 *   - Bundle (Title startet mit "Bundle:") → "Special Deal" Badge in Rot
 *   - Sonst → "Sale" Badge in Rot
 * Position: neben dem Streichpreis, ähnlich wie im Mango-Original.
 * Greift auf PDP H1 + Product-Cards [data-product-title].
 */
(function () {
  'use strict';

  function badgeFor(titleText) {
    if (!titleText) return null;
    if (/^\s*bundle\s*:/i.test(titleText)) return 'Special Deal';
    return 'Sale';
  }

  function processPriceBlock(priceEl, titleText) {
    if (!priceEl) return;
    // Streichpreis nur wenn compare-at-price (oder ähnliches) vorhanden + sichtbar
    var compareAt = priceEl.querySelector('.compare-at-price, .price__compare, .price__regular--sale, s, del');
    if (!compareAt) return;
    var compareText = (compareAt.textContent || '').trim();
    if (!compareText) return;
    var label = badgeFor(titleText);
    if (!label) return;
    // schon vorhanden? DOM-Check, NICHT JS-Property (overlebt morph nicht)
    if (priceEl.querySelector('.bak-sale-badge')) return;
    var span = document.createElement('span');
    span.className = 'bak-sale-badge';
    span.textContent = label;
    // direkt nach dem compare-at Element einfügen
    compareAt.parentElement.insertBefore(span, compareAt.nextSibling);
  }
  // Expose für Variant-Update Hooks
  window.__bakProcessPrice = function(container, title) {
    var prices = container.querySelectorAll ? container.querySelectorAll('product-price, .price') : [];
    Array.prototype.forEach.call(prices, function(pe){ processPriceBlock(pe, title); });
  };

  function processAll() {
    // NUR PDP — Cards bewusst NICHT (User-Vorgabe 2026-05-28)
    var pdpH1 = document.querySelector('.product-information h1');
    var pdpTitle = pdpH1 && pdpH1.textContent.trim();
    document.querySelectorAll('.product-information product-price, .product-information .price').forEach(function (pe) {
      processPriceBlock(pe, pdpTitle);
    });
  }

  var t = null;
  function schedule() {
    if (t) clearTimeout(t);
    t = setTimeout(processAll, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  document.addEventListener('shopify:section:load', schedule);
  // Sofort-Re-Inject bei Variant-Update + bei Change auf variant-picker
  function processNow() { processAll(); }
  document.addEventListener('variant:update', processNow);
  document.addEventListener('change', function(e){
    if (e.target && e.target.closest && e.target.closest('variant-picker')) {
      setTimeout(processNow, 0);   // direkt nach Microtask (morph fertig)
      setTimeout(processNow, 50);  // Backup
      setTimeout(processNow, 200); // Backup für lange Fetches
    }
  }, true);
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (muts) {
      var trigger = false;
      for (var i = 0; i < muts.length && !trigger; i++) {
        var added = muts[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.classList && (n.classList.contains('compare-at-price') || n.tagName === 'PRODUCT-PRICE')) ||
              (n.querySelector && (n.querySelector('.compare-at-price') || n.querySelector('product-price')))) {
            trigger = true; break;
          }
        }
        // Auch wenn ein product-price entfernt UND neu eingefügt wird (morph)
        var removed = muts[i].removedNodes;
        if (!trigger && removed) {
          for (var k = 0; k < removed.length; k++) {
            var rn = removed[k];
            if (rn.nodeType === 1 && rn.tagName === 'PRODUCT-PRICE') { trigger = true; break; }
          }
        }
      }
      if (trigger) processNow();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
 * bAK Sale-Badge Card-Cleanup (Cowork 2026-05-28)
 * Falls von früherer Version Badges in Cards stehen, beim Init wegräumen.
 */
(function () {
  'use strict';
  function cleanup() {
    document.querySelectorAll('product-card .bak-sale-badge').forEach(function (b) { b.remove(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup);
  } else {
    cleanup();
  }
  document.addEventListener('shopify:section:load', cleanup);
})();

/*
 * bAK ONE SIZE Pre-Morph Hook (Cowork 2026-05-28)
 * ────────────────────────────────────────────────
 * Monkey-patcht QuickAddComponent.updateQuickAddModal damit unser ONE SIZE
 * Stub IN das productGrid (Source-HTML) injiziert wird BEVOR Horizons morph
 * läuft. Dadurch hat morph den Stub auf beiden Seiten (Quelle + Ziel) und
 * behält ihn → kein Flash beim Größenwechsel.
 */
(function () {
  'use strict';
  function tryPatch() {
    var QAC = customElements.get('quick-add-component');
    if (!QAC || QAC.prototype.__bakOneSizePatched) return false;
    var original = QAC.prototype.updateQuickAddModal;
    if (typeof original !== 'function') return false;
    QAC.prototype.updateQuickAddModal = async function (productGrid) {
      try {
        if (productGrid) {
          var title = this.dataset.productTitle || '';
          // 1) Multi-Picker Labels (bak-picker-name) ZUERST — Label kommt in die Form
          if (typeof window.__bakProcessMultiPicker === 'function') {
            window.__bakProcessMultiPicker(productGrid);
          }
          // 2) ONE SIZE Stub für Bundles
          if (typeof window.__bakInjectOneSizeRows === 'function') {
            window.__bakInjectOneSizeRows(productGrid, title);
          }
        }
      } catch (e) { /* swallow */ }
      return original.call(this, productGrid);
    };
    QAC.prototype.__bakOneSizePatched = true;
    return true;
  }

  // Polling damit wir den Patch installieren sobald QuickAddComponent definiert ist
  var attempts = 0;
  function poll() {
    if (tryPatch()) return;
    if (attempts++ < 100) setTimeout(poll, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();

/*
 * bAK Variant-Picker Pre-Morph Hook (Cowork 2026-05-28)
 * ─────────────────────────────────────────────────────
 * variant-picker.js morpht den picker beim Size-Wechsel. Dabei fallen Labels
 * (bak-picker-name) und ONE SIZE Stub raus → Flash. Wir injizieren beide IN
 * den newVariantPickerSource VOR dem morph.
 */
(function () {
  'use strict';

  function findProductTitle(varPickerEl) {
    // Quick-Add Modal: title vom quick-add-component oder modal data-attr
    var modal = varPickerEl.closest && varPickerEl.closest('dialog.quick-add-modal');
    if (modal) {
      var handle = modal.getAttribute('data-bak-current-handle');
      if (handle) {
        // Suche nach quick-add-component das diesen handle triggert (oder fallback)
        var qac = document.querySelector('quick-add-component[data-bak-last-triggered="true"]');
        if (qac && qac.dataset.productTitle) return qac.dataset.productTitle;
      }
      // Modal-Title H1
      var h1 = modal.querySelector('h1, h2, .product-title');
      if (h1) return h1.textContent.trim();
    }
    // PDP
    var pdp = varPickerEl.closest('.product-information');
    if (pdp) {
      var pdpH1 = pdp.querySelector('h1');
      if (pdpH1) return pdpH1.textContent.trim();
    }
    return '';
  }

  function tryPatch() {
    var VP = customElements.get('variant-picker');
    if (!VP || VP.prototype.__bakPatched) return false;
    var orig = VP.prototype.updateVariantPicker;
    if (typeof orig !== 'function') return false;
    VP.prototype.updateVariantPicker = function (newHtml) {
      try {
        var newSource = newHtml && newHtml.querySelector && newHtml.querySelector(this.tagName.toLowerCase());
        if (newSource) {
          // Labels zuerst (kommt in den form)
          if (typeof window.__bakProcessMultiPicker === 'function') {
            window.__bakProcessMultiPicker(newSource);
          }
          // Dann ONE SIZE Stub (braucht Title)
          if (typeof window.__bakInjectOneSizeRows === 'function') {
            var title = findProductTitle(this);
            window.__bakInjectOneSizeRows(newSource, title);
          }
        }
      } catch (e) { /* swallow */ }
      return orig.call(this, newHtml);
    };
    VP.prototype.__bakPatched = true;
    return true;
  }

  var attempts = 0;
  function poll() {
    if (tryPatch()) return;
    if (attempts++ < 100) setTimeout(poll, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();

/*
 * [REVERTED 2026-06-03] bAK PDP Video-Slide + Slideshow Desktop-Instant raus.
 *
 * User-Vorgabe: "mach mal alle deine Änderungen wieder raus, lass mal die
 * funktionalität des themes oben wieder haben was das durchscrollen usw.
 * betrifft". Sowohl der data-bak-has-video Marker als auch die select()-
 * Prototype-Patch und der Click-aufs-Bild-Handler sind raus. Horizon-
 * Default-Verhalten für die PDP-Slideshow.
 */
